import React from "react";
import { NavLink } from "react-router-dom";

const HomeContent = () => (
  <div className="hero home ">
    <p className="">
      <NavLink
        to="/paku-app"
        exact
        className=""
        activeClassName="router-link-exact-active"
      >
        Paku App
      </NavLink>{" "}
      is the system that allows us to keep the information in our Biobank
      ordered, secure and traceable.
    </p>
    <p className="">
      <NavLink
        to="/pipelines"
        exact
        className=""
        activeClassName="router-link-exact-active"
      >
        Pipelines
      </NavLink>{" "}
      <small>(coming soon) </small>
    </p>
    <p className="">
      <NavLink
        to="/customers-reports"
        exact
        className=""
        activeClassName="router-link-exact-active"
      >
        Backup Management Systems
      </NavLink>{" "}
      <small>(coming soon) </small>
    </p>
    <p className="">
      <NavLink
        to="/customers-reports"
        exact
        className=""
        activeClassName="router-link-exact-active"
      >
        AI Image Processing
      </NavLink>{" "}
      <small>(coming soon) </small>
    </p>
    <p className="">
      <NavLink
        to="/customers-reports"
        exact
        className=""
        activeClassName="router-link-exact-active"
      >
        Customers Reports
      </NavLink>{" "}
      <small>(coming soon) </small>
    </p>
    <p className="">
      <NavLink
        to="/customers-reports"
        exact
        className=""
        activeClassName="router-link-exact-active"
      >
        Nanopore Files
      </NavLink>{" "}
      <small>(coming soon) </small>
    </p>
  </div>
);

export default HomeContent;
